import React from "react";
import Box from "@mui/material/Box";
import InputLabel from "@mui/material/InputLabel";
import FormControl from "@mui/material/FormControl";
import { MenuItem, Select } from "@mui/material";
import { useUnit } from "effector-react";
import { CustomersStore } from "../../../../stores/CustomersStore/CustomersStore";
import { Customer } from "../../../../types/customers.types";

interface Props {
  client: Customer;
  onChange?: (client: Customer) => void;
}

const SelectClient: React.FC<Props> = ({ client, onChange }) => {
  const { customers } = useUnit(CustomersStore);

  const handleChange = (e: any) => {
    const selected = customers.find((c) => c.id === e.target.value);
    if (selected && onChange) onChange(selected);
  };

  return (
    <Box sx={{ minWidth: 200 }}>
      <FormControl fullWidth disabled={!customers?.length}>
        <InputLabel variant="outlined" htmlFor="select-client">
          Cliente
        </InputLabel>
        <Select
          labelId="select-client"
          value={client?.id ?? ""}
          label="Cliente"
          onChange={handleChange}
        >
          {customers?.map((c) => (
            <MenuItem key={c.id} value={c.id}>
              {c.name}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </Box>
  );
};

export default SelectClient;
